import { useEffect, useState } from 'react';
export const MEDIA_QUERY_BREAKPOINTS = {
  sm: `(max-width: 48rem)`
};
const useMediaQuery = mediaQuery => {
  const [isMatching, setIsMatching] = useState(!!window.matchMedia(mediaQuery).matches);
  useEffect(() => {
    const mql = window.matchMedia(mediaQuery);
    const changeHandler = e => setIsMatching(!!e.matches);
    mql.addEventListener('change', changeHandler);
    return () => {
      mql.removeEventListener('change', changeHandler);
    };
  }, [mediaQuery]);
  return isMatching;
};
export default useMediaQuery;